// @ts-nocheck
/* eslint-disable */
export const appReadyV216Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 8.5L7.5 11.0977L12 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`,
    name: 'ready-v-2-16' as const
};